import { call, takeLatest, select, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { without } from 'ramda';
import { makeBackendApi, OffersSearchSuccessResponse, MealPlanNames } from 'services/BackendApi';
import { ALL_COUNTRIES_AND_RESORTS } from '../constants';
import {
  OFFERS_SEARCH_REQUEST,
  offersSearchFailureAction,
  offersSearchSuccessAction,
  SearchRequestAction,
} from '../actions';
import { clearBookingBuilderAction } from 'store/modules/bookingBuilder';
import { selectedTaSelector } from '../../agents';
import { isInternalUser } from 'store/modules/auth/selectors';

export function* offersSearchRequestSaga(action: SearchRequestAction) {
  // We need to sanitize the query a little
  const query = action.query;
  const sanitizedQuery = {
    ...query,
    startDate: query.startDate.split('T')[0],
    endDate: query.endDate.split('T')[0],
    name: action.query.name === ALL_COUNTRIES_AND_RESORTS ? '' : action.query.name,
    mealPlanCategories: without([MealPlanNames.ANY], query.mealPlanCategories),
  };
  // @ts-ignore
  delete sanitizedQuery.tauuid;
  // @ts-ignore
  delete sanitizedQuery.taUuid;
  // @ts-ignore
  delete sanitizedQuery.companyUuid;
  // @ts-ignore
  delete sanitizedQuery.hotelUuid;

  const isInternal: boolean = yield select(isInternalUser);
  try {
    const selectedTa = yield select(selectedTaSelector);
    const backendApi = makeBackendApi(selectedTa?.uuid);
    if (!selectedTa && isInternal) {
      return;
    }
    delete sanitizedQuery.membership;

    const result: AxiosResponse<OffersSearchSuccessResponse> = yield call(backendApi.getOffersSearch, sanitizedQuery);
    yield put(offersSearchSuccessAction(result.data));
    yield put(clearBookingBuilderAction());
  } catch (e) {
    yield put(offersSearchFailureAction(e));
    yield put(clearBookingBuilderAction());
  }
}

export function* watchOffersSearchRequest() {
  yield takeLatest(OFFERS_SEARCH_REQUEST, offersSearchRequestSaga);
}
